<div class="width-1200">

    <mat-card>

        <mat-toolbar class="toolbar-top">

            <div class='title'>
                <mat-icon>supervisor_account</mat-icon>
                <div style='font-size: 17px;'>
                    Acompanhante
                </div>

            </div>

        </mat-toolbar>

    </mat-card>


    <mat-card>
        <mat-form-field class="full-width">
            <input matInput #pacienteEscolhido type="text" placeholder="Usuário (4 letras iniciais)"
                [matAutocomplete]="autoPaciente" [formControl]="searchMemberControl">

            <mat-autocomplete #autoPaciente="matAutocomplete" [displayWith]="displayMember.bind(this)">
                <mat-option *ngFor="let member of members" [value]="member">
                    {{ member.member_name }}
                    <span *ngIf="member.member_email"> | <small>{{ member.member_email }}</small></span>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </mat-card>

    <mat-card *ngIf='flagSelected'>


        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>supervisor_account</mat-icon>
                    <div>Registrar</div>
                </ng-template>


                <div style='height: 200px;'>

                    <div style='padding:10px 0 10px 0; margin-top: 20px;'>
                        {{entityForm.controls.member_name.value}}
                    </div>
                    <div style='padding:10px 0 10px 0;'>
                        {{entityForm.controls.member_email.value}}
                    </div>

                    <hr>

                    <mat-form-field class="full-width">
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.name" placeholder="Nome do acompanhante"
                            autocomplete="off">
                        <mat-error *ngIf="entityForm.controls.name.hasError('required')">
                            O nome do acompanhante é obrigatório
                        </mat-error>
                    </mat-form-field>

                </div>

                <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
                    <div [ngClass]="{hidden: !spinner}">
                        <mat-spinner diameter="30"></mat-spinner>
                    </div>
                    <button mat-raised-button (click)='registerCompanion()' [disabled]="entityForm.invalid">
                        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
                    </button>
                </div>

            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>list</mat-icon>
                    <div>Acompanhantes</div>
                </ng-template>

                <div style='height: 270px;'>

                    <!-- TABLE -->
                    <mat-table style='height: 250px; overflow: auto;' [dataSource]="dataSource" matSort matSortDisableClear=true>

                        <!-- Icon Column -->
                        <ng-container matColumnDef="icon">
                            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <mat-icon style='font-size:1.2em; margin-top:10px;'>store_mall_directory</mat-icon>
                            </mat-cell>
                        </ng-container>

                        <!-- mamber_name Column -->
                        <ng-container matColumnDef="member_name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Usuário </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
                        </ng-container>

                        <!-- name Column -->
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Acompanhante </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
                        </ng-container>


                        <!-- Header -->
                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                        <!-- Row -->
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

                    </mat-table>
                    <!-- END TABLE -->

                </div>

            </mat-tab>

        </mat-tab-group>
    </mat-card>


</div>